import axiosAuth from "@/services/axiosAuth";
import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { DASHBOARD_PM_QUALITY_AUDIT_SUMMARY_API } from "./apiRoutes";

interface Props {
  projectId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getQualityAuditSummary = async (projectId: string) => {
  return await axiosAuth.get(`${DASHBOARD_PM_QUALITY_AUDIT_SUMMARY_API(projectId)}`);
};

const useGetPmQualityAuditSummary = ({ projectId, queryParams }: Props): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["dashboard-quality-audit-summary", projectId],
    queryFn: () => getQualityAuditSummary(projectId),
    select: (data: any) => data.data.data,
    refetchOnWindowFocus: false,
    enabled: !!projectId,
    ...queryParams,
  });
};

export default useGetPmQualityAuditSummary;
